/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOilStoreDto } from '../models/CreateOilStoreDto';
import type { CreateOilStoreEntity } from '../models/CreateOilStoreEntity';
import type { DeleteOilStoreEntity } from '../models/DeleteOilStoreEntity';
import type { GetListPointTransactionEntity } from '../models/GetListPointTransactionEntity';
import type { GetNearbyOilStoresEntity } from '../models/GetNearbyOilStoresEntity';
import type { GetOilStoreListEntity } from '../models/GetOilStoreListEntity';
import type { PayOilByBankTransferDto } from '../models/PayOilByBankTransferDto';
import type { PayOilByBankTransferEntity } from '../models/PayOilByBankTransferEntity';
import type { PayOilByBidvTransferDto } from '../models/PayOilByBidvTransferDto';
import type { PayOilByBidvTransferEntity } from '../models/PayOilByBidvTransferEntity';
import type { PayOilByMorapayDto } from '../models/PayOilByMorapayDto';
import type { PayOilByMorapayEntity } from '../models/PayOilByMorapayEntity';
import type { UpdateOilStoreDto } from '../models/UpdateOilStoreDto';
import type { UploadOilStoreLicenseImageDto } from '../models/UploadOilStoreLicenseImageDto';
import type { UploadTransactionImageEntity } from '../models/UploadTransactionImageEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OilStoreService {
  /**
   * @param requestBody
   * @returns UploadTransactionImageEntity
   * @throws ApiError
   */
  public static oilStoreControllerUploadTransactionImage(
    requestBody: UploadOilStoreLicenseImageDto,
  ): CancelablePromise<UploadTransactionImageEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/oil-stores/upload-oil-store-business-license',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param requestBody
   * @returns CreateOilStoreEntity
   * @throws ApiError
   */
  public static oilStoreControllerCreate(
    requestBody: CreateOilStoreDto,
  ): CancelablePromise<CreateOilStoreEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/oil-stores',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param search Tìm kiếm theo tên cửa hàng
   * @param province Lọc theo tỉnh
   * @param district Lọc theo quận/huyện
   * @param ward Lọc theo phường/xã
   * @param page
   * @param limit
   * @returns GetOilStoreListEntity
   * @throws ApiError
   */
  public static oilStoreControllerGetList(
    search?: string,
    province?: string,
    district?: string,
    ward?: string,
    page: string = '1',
    limit: string = '20',
  ): CancelablePromise<GetOilStoreListEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/oil-stores',
      query: {
        search: search,
        province: province,
        district: district,
        ward: ward,
        page: page,
        limit: limit,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns CreateOilStoreEntity
   * @throws ApiError
   */
  public static oilStoreControllerUpdate(
    id: string,
    requestBody: UpdateOilStoreDto,
  ): CancelablePromise<CreateOilStoreEntity> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/oil-stores/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param id
   * @returns CreateOilStoreEntity
   * @throws ApiError
   */
  public static oilStoreControllerGetDetail(
    id: string,
  ): CancelablePromise<CreateOilStoreEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/oil-stores/{id}',
      path: {
        id: id,
      },
    });
  }

  /**
   * @param id
   * @returns DeleteOilStoreEntity
   * @throws ApiError
   */
  public static oilStoreControllerDelete(
    id: string,
  ): CancelablePromise<DeleteOilStoreEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/oil-stores/{id}',
      path: {
        id: id,
      },
    });
  }

  /**
   * Lấy danh sách cây xăng gần đây
   * @param lat Vĩ độ (latitude) của driver
   * @param lng Kinh độ (longitude) của driver
   * @param search Tìm kiếm theo tên cửa hàng, địa chỉ
   * @param typeId Lọc theo typeId
   * @param page
   * @param limit
   * @returns GetNearbyOilStoresEntity
   * @throws ApiError
   */
  public static oilStoreControllerGetNearbyOilStores(
    lat?: string,
    lng?: string,
    search?: string,
    typeId?: string,
    page: string = '1',
    limit: string = '20',
  ): CancelablePromise<GetNearbyOilStoresEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/oil-stores/nearby',
      query: {
        lat: lat,
        lng: lng,
        search: search,
        typeId: typeId,
        page: page,
        limit: limit,
      },
    });
  }

  /**
   * Thanh toán xăng dầu thông qua chuyển khoản ngân hàng bên ngoài
   * @param requestBody
   * @returns PayOilByBankTransferEntity
   * @throws ApiError
   */
  public static oilStoreControllerPayOilByTransferBank(
    requestBody: PayOilByBankTransferDto,
  ): CancelablePromise<PayOilByBankTransferEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/oil-stores/pay-oil/bank-transfer',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Thanh toán xăng dầu thông qua BIDV
   * @param requestBody
   * @returns PayOilByBidvTransferEntity
   * @throws ApiError
   */
  public static oilStoreControllerPayOilByBidvTransferBank(
    requestBody: PayOilByBidvTransferDto,
  ): CancelablePromise<PayOilByBidvTransferEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/oil-stores/pay-oil/bidv-bank-transfer',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Thanh toán xăng dầu bằng MoraPay
   * @param requestBody
   * @returns PayOilByMorapayEntity
   * @throws ApiError
   */
  public static oilStoreControllerPayOilByMorapay(
    requestBody: PayOilByMorapayDto,
  ): CancelablePromise<PayOilByMorapayEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/oil-stores/pay-oil/morapay',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Upload logo cửa hàng xăng dầu
   * @param requestBody
   * @returns UploadTransactionImageEntity
   * @throws ApiError
   */
  public static oilStoreControllerUploadOilStoreLogo(
    requestBody: UploadOilStoreLicenseImageDto,
  ): CancelablePromise<UploadTransactionImageEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/oil-stores/upload-oil-store-logo',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * List Oil Store Transactions
   * @param transactionStatus Search by Trans's status
   * @param fromTime From Time
   * @param toTime To Time
   * @param transactionCode Search by Trans's code
   * @param transactionType Search by Trans's type
   * @param fromUserSearchString Search by user's name or phone number(User Send)
   * @param toUserSearchString Search by user's name or phone number(User Receive)
   * @param searchDetailContent Search keyword in detail contents
   * @param page Page
   * @param pageSize Page size
   * @param userMerchantId Lọc theo merchant user
   * @param bankAccountNumber Lọc theo số tài khoản ngân hàng
   * @returns GetListPointTransactionEntity
   * @throws ApiError
   */
  public static oilStoreControllerGetListOilStoreTrans(
    transactionStatus:
      | 'Tất cả'
      | 'Thành công'
      | 'Thất bại'
      | 'Đã hủy'
      | 'Đang chờ hủy'
      | 'Đang xử lý',
    fromTime: string,
    toTime: string,
    transactionCode?: string,
    transactionType?: 'Tất cả' | 'Thanh toán' | 'Nhận thanh toán',
    fromUserSearchString?: string,
    toUserSearchString?: string,
    searchDetailContent?: string,
    page: string = '1',
    pageSize: string = '10',
    userMerchantId?: string,
    bankAccountNumber?: string,
  ): CancelablePromise<GetListPointTransactionEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/oil-stores/transactions',
      query: {
        transactionCode: transactionCode,
        transactionType: transactionType,
        transactionStatus: transactionStatus,
        fromTime: fromTime,
        toTime: toTime,
        fromUserSearchString: fromUserSearchString,
        toUserSearchString: toUserSearchString,
        searchDetailContent: searchDetailContent,
        page: page,
        pageSize: pageSize,
        userMerchantId: userMerchantId,
        bankAccountNumber: bankAccountNumber,
      },
      errors: {
        401: `Unauthorized`,
        500: `Internal server error`,
      },
    });
  }
}
